/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import './AppNavFilePreview.scss';

import { Card, Icons } from '../../../../bphComponents/bundle';
import COLORS from '../../../styles/Colors';
import FlexRow from '../../../components/FlexRow';
import { isMobileApplication } from '../../../../utilities/MobileUtil';

const AppNavFilePreview = props => {
  const { download, share, done, fileDownloadUrl } = props;

  return (
    <div className="cmp-appnavfilepreview" style={{ paddingTop: isMobileApplication() ? 4 : 28 }}>
      <Card.CardShape className="bkgd-color-gsMedDarkDT">
        <Card.CardContent>
          <FlexRow>
            <div style={{ display: 'flex' }}>
              {share && share.onClick ? (
                <button
                  disabled={share.disabled}
                  style={{
                    marginRight: 28,
                  }}
                  onClick={() => {
                    if (share.disabled) { return; }
                    share.onClick(fileDownloadUrl);
                  }}
                >
                  <Icons.IconShare.Medium color={share.disabled ? COLORS.gsMiddleLT : COLORS.gsLightest} />
                </button>
              ) : (
                <div />
              )}
              {download && download.onClick ? (
                <button
                  disabled={download.disabled}
                  onClick={() => {
                    if (download.disabled) { return; }
                    download.onClick(fileDownloadUrl);
                  }}
                >
                  <Icons.IconDownload.Medium color={download.disabled ? COLORS.gsMiddleLT : COLORS.gsLightest} />
                </button>
              ) : (
                <div />
              )}
            </div>
            <button
              className={`font-footnote__STATIC ${done.disabled ? 'font-color-gsMiddleLT' : 'font-color-gsLightest'}`}
              disabled={done.disabled}
              onClick={done.disabled ? done.onDisabledClick : done.onClick}
            >
              <FormattedMessage id="nav.done.button.label" />
            </button>
          </FlexRow>
        </Card.CardContent>
      </Card.CardShape>
    </div>
  );
};

export default AppNavFilePreview;
